
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.348 12.783v5.913c0 .609-.478 1.087-1.087 1.087H1.739a1.076 1.076 0 01-1.087-1.087v-5.913c0-.609.479-1.087 1.087-1.087.609 0 1.087.478 1.087 1.087v4.826h14.348v-4.826c0-.609.478-1.087 1.087-1.087s1.087.478 1.087 1.087zm-10.13 1.348c.195.217.478.326.782.326.305 0 .565-.109.783-.326l4.326-4.435a1.096 1.096 0 00-.022-1.543 1.096 1.096 0 00-1.543.021l-2.457 2.544V1.305C11.087.696 10.61.218 10 .218S8.913.696 8.913 1.305v9.413L6.435 8.196c-.413-.435-1.109-.435-1.544-.022-.434.413-.434 1.109-.021 1.544l4.348 4.413z","fill":"#56BFC7"}})])
          )
        }
      }
    